import axios from 'axios';
import AuthService from './auth-header';
import { applyAiCallingCatalog } from '@/utils/ai-calling-catalog';
import { applyInvoiceColumnTypeCatalog } from '@/utils/invoice-column-types';
// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ // const API_URL = 'https://ats.sattvahuman.in/api/';

let API_URL = ''
    if (process.env.NODE_ENV === "production") {
        API_URL = 'https://ats.sattvahuman.in/api/'
    } else {
        API_URL = 'http://192.168.0.30:5000/api/'
    }





class AdminConfigService {
    normalizeResponse(res) {
        if (res && res.data && typeof res.data === 'object') return res.data
        return res
    }

    normalizeError(err) {
        const body = err?.response?.data
        if (body && typeof body === 'object') return body
        return {
            status: 'FAILED',
            message: err?.message || 'Request failed',
        }
    }

    async create(data) {
        try {
            const res = await axios.post(API_URL + 'admin/config', data,
                {
                    headers: AuthService.authHeader()
                });
            return this.normalizeResponse(res);
        }
        catch (err) {
            console.log(err.response)
            return this.normalizeError(err);
        }

    }

    async getConfig(module_name, param_name) {
        try {
            const encodedModule = encodeURIComponent(module_name)
            const encodedParam = encodeURIComponent(param_name)
            const res = await axios.get(
                `${API_URL}admin/config/${encodedModule}/${encodedParam}`,
                {
                    headers: AuthService.authHeader()
                });
            const body = this.normalizeResponse(res)
            if (/invoice/i.test(String(module_name || ''))) {
                applyInvoiceColumnTypeCatalog(body)
            }
            return body
        }
        catch (err) {
            console.log(err.response)
            return this.normalizeError(err)
        }
    }

    async getConfigPowerBI(module, role, empId) {
        try {
            const res = await axios.get(API_URL + 'admin/powerbi/config?module=' + module + '&role=' + role + '&empId=' + empId,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }

    async getConfigExpense() {
        try {
            const res = await axios.get(API_URL + 'admin/config/expense/',
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getConfigInfra() {
        try {
            const res = await axios.get(API_URL + 'admin/config/infra',
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getATSDropdownList() {
        try {
            const res = await axios.get(API_URL + 'admin/config/menu',
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getClientDropdownList(clientName) {
        try {
            const res = await axios.get(API_URL + 'admin/list/' + clientName,
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    // async getRelianceDropdownList() {
    //     try {
    //         const res = await axios.get(API_URL + 'admin/list/reliance/',
    //             {
    //                 headers: AuthService.authHeader()
    //             });
    //         return res
    //     }
    //     catch (err) {
    //         console.log(err.response)
    //         return err.response
    //     }
    // }
    async getJobsDropdownList() {
        try {
            const res = await axios.get(API_URL + 'admin/config/jobs',
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getProjectDropdownList() {
        try {
            const res = await axios.get(API_URL + 'admin/config/project',
                {
                    headers: AuthService.authHeader()
                });
            //console.log(res.data)
            return res
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async update(id, data) {
        try {
            const res = await axios.put(`${API_URL}admin/config/${id}`,
                data,
                {
                    headers: AuthService.authHeader()
                });
            return this.normalizeResponse(res);
        }
        catch (err) {
            console.log(err.response)
            return this.normalizeError(err);
        }
    }

    async deleteConfig(id) {
        try {
            const res = await axios.delete(`${API_URL}admin/config/${id}`,
                {
                    headers: AuthService.authHeader()
                });
            return this.normalizeResponse(res);
        }
        catch (err) {
            console.log(err.response)
            return this.normalizeError(err);
        }
    }

    /** @deprecated Use deleteConfig — kept for any legacy callers */
    async delete(id) {
        return this.deleteConfig(id)
    }

    async getKPMGRPOConfig() {
        try {
            const res = await axios.get(API_URL + 'admin/config/kpmg-rpo',
                {
                    headers: AuthService.authHeader()
                });
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }
    async getExotelConfig() {
        try {
            const res = await axios.get(API_URL + 'admin/config/exotel',
                {
                    headers: AuthService.authHeader()
                });
            return res.data
        }
        catch (err) {
            console.log('exotel config service.response', err.response)
            return err.response
        }
    }

    /**
     * Agent calling flag (DID holders).
     * GET /api/exotel/agent-availability → { emp_id, calls_available }
     * Optional empId sends ?emp_id= so outbound can check the From-DID owner
     * (not only the logged-in user). PUT remains own-flag only.
     * @param {string} [empId]
     */
    async getAgentAvailability(empId) {
        try {
            const params = {}
            if (empId != null && String(empId).trim() !== '') {
                params.emp_id = String(empId).trim()
            }
            const res = await axios.get(API_URL + 'exotel/agent-availability',
                {
                    headers: AuthService.authHeader(),
                    params,
                });
            return res.data
        }
        catch (err) {
            console.log('exotel agent-availability get service.response', err.response)
            return err.response
        }
    }

    /**
     * PUT /api/exotel/agent-availability body { calls_available: boolean }
     * @param {{ calls_available: boolean }} data
     */
    async setAgentAvailability(data) {
        try {
            const res = await axios.put(API_URL + 'exotel/agent-availability',
                data,
                {
                    headers: AuthService.authHeader()
                });
            return res.data
        }
        catch (err) {
            console.log('exotel agent-availability put service.response', err.response)
            return err.response
        }
    }

    unwrapAiCallingConfig(body) {
        if (!body || typeof body !== 'object') return {}
        if (body.data && typeof body.data === 'object' && !Array.isArray(body.data)) {
            return body.data
        }
        return body
    }

    async getAiCallingConfig() {
        try {
            const res = await axios.get(API_URL + 'admin/config/ai-calling',
                {
                    headers: AuthService.authHeader()
                });
            const body = res.data
            applyAiCallingCatalog(this.unwrapAiCallingConfig(body))
            return body
        }
        catch (err) {
            console.log('ai-calling config service.response', err.response)
            return err.response?.data || err.response
        }
    }

    /**
     * Save AI Calling admin config (numbers, TTS, special grants, templates).
     * Uses generic POST admin/config with module marker when dedicated PUT is unavailable.
     * @param {Object} data
     */
    async saveAiCallingConfig(data) {
        try {
            const payload = {
                module: 'ai-calling',
                module_name: 'ai-calling',
                ...data,
            }
            const res = await axios.post(API_URL + 'admin/config/ai-calling',
                payload,
                {
                    headers: AuthService.authHeader()
                });
            applyAiCallingCatalog(data)
            return res.data
        }
        catch (err) {
            // Fallback to generic create if dedicated route is not yet deployed
            try {
                const fallback = await axios.post(API_URL + 'admin/config',
                    {
                        module: 'ai-calling',
                        module_name: 'ai-calling',
                        param_name: 'settings',
                        data,
                    },
                    {
                        headers: AuthService.authHeader()
                    });
                applyAiCallingCatalog(data)
                return fallback.data
            } catch (fallbackErr) {
                console.log('ai-calling config save service.response', err.response || fallbackErr.response)
                return err.response || fallbackErr.response
            }
        }
    }

    async makeExotelCall(callData) {
        // Dynamic require avoids circular import with exotel-agent-availability.js
        try {
            // eslint-disable-next-line global-require
            const { assertCallsAvailableForDial } = require('@/utils/exotel-agent-availability')
            const gate = await assertCallsAvailableForDial(callData || {})
            if (gate && gate.ok === false) {
                return gate.response
            }
        } catch (gateErr) {
            console.log('exotel availability gate error', gateErr)
            return {
                status: 403,
                data: {
                    message: 'Calling is paused. Outbound is blocked while unavailable.',
                    code: 'CALLS_UNAVAILABLE',
                },
            }
        }

        try {
            const res = await axios.post(API_URL + 'exotel/make-call',
                callData,
                {
                    headers: AuthService.authHeader()
                });
            return res.data
        }
        catch (err) {
            console.log('exotel make call service.response', err.response)
            return err.response
        }
    }

    async getReportingManagersList() {
        try {
            const res = await axios.get(API_URL + 'admin/config/intellismart/reporting-managers',
                {
                    headers: AuthService.authHeader()
                });
            return res
        }
        catch (err) {
            console.log('getReportingManagersList service.response', err.response)
            return err.response
        }
    }

}

export default new AdminConfigService();